"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.B2B_CTA_FORM = exports.BUY_ONECLICK_FORM = void 0;
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var styles_1 = __importStar(require("./styles"));
var atoms_1 = require("../../styles/atoms");
var buy_in_one_click_1 = require("../../ItemApp/ducks/buy-in-one-click");
var CloseIconSmall_1 = __importDefault(require("../Icons/CloseIconSmall"));
var GenericModal_1 = __importDefault(require("../GenericModal"));
var GenericInput_1 = __importStar(require("../GenericInput"));
var InputMask_1 = __importDefault(require("../PhoneField/InputMask"));
var react_redux_1 = require("react-redux");
var utils_1 = require("./utils");
exports.BUY_ONECLICK_FORM = 'buy_one_click_form';
exports.B2B_CTA_FORM = 'sample_order_request';
var PopupForm = function (props) {
    var open = props.open, onClose = props.onClose, formName = props.formName, requestName = props.requestName, onSubmit = props.onSubmit;
    var buyInOneClick = (0, react_redux_1.useSelector)(buy_in_one_click_1.buyInOneClickSelector);
    var dialogRef = (0, react_1.useRef)(null);
    var iconref = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(''), success = _a[0], setSuccess = _a[1];
    var _b = (0, react_1.useState)(''), error = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)(false), phoneErr = _c[0], setPhoneErr = _c[1];
    var _d = (0, react_1.useState)(false), emailErr = _d[0], setEmailErr = _d[1];
    var _e = (0, react_1.useState)(false), loading = _e[0], setLoading = _e[1];
    var _f = (0, react_1.useState)((buyInOneClick === null || buyInOneClick === void 0 ? void 0 : buyInOneClick.fields.email) ? buyInOneClick.fields.email : ''), email = _f[0], setEmail = _f[1];
    var _g = (0, react_1.useState)((buyInOneClick === null || buyInOneClick === void 0 ? void 0 : buyInOneClick.fields.phone) ? (0, utils_1.phoneFormatter)(buyInOneClick.fields.phone) : ''), phone = _g[0], setPhone = _g[1];
    (0, react_1.useEffect)(function () {
        if (!open || formName === exports.BUY_ONECLICK_FORM)
            return;
        loadRecaptchaWithoutDefence();
    }, [open]);
    var submit = function () {
        var _a, _b;
        var gRecaptchaResponse = (_b = (_a = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.g-recaptcha-response')) === null || _b === void 0 ? void 0 : _b.value;
        var formData = new FormData();
        formData.append('authenticity_token', props.authToken);
        formData.append("".concat(formName, "[email]"), email);
        formData.append("".concat(formName, "[phone]"), phone);
        if (props.productId)
            formData.append('product_id', props.productId);
        formData.append('g-recaptcha-response', gRecaptchaResponse);
        setLoading(true);
        axios_1.default
            .post(requestName, formData)
            .then(function (res) {
            var _a, _b;
            if (res.data.response || res.data.order) {
                setError('');
                animateModal(onClose, dialogRef, iconref);
                onSubmit && onSubmit((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.order) === null || _b === void 0 ? void 0 : _b.code);
            }
            else {
                setSuccess('');
                setError(res.data.error);
            }
        })
            .catch(function (err) {
            console.log(err);
            setSuccess('');
            setError('Ошибка на сервере, попробуйте еще раз');
        })
            .finally(function () { return setLoading(false); });
    };
    var changeEmail = function (e) {
        return setEmail(e.target.value);
    };
    var changePhone = function (value) { return setPhone(value); };
    var handleClose = function () {
        onClose && onClose();
    };
    var phoneValid = function (phone) {
        return /_/.test(phone) || phone.length === 1 || phone.length === 2;
    };
    var emailValid = function (email) {
        return !/\S+@\S+\.\S+/.test(email) && email.length > 0;
    };
    var blurEmail = function (e) {
        return setEmailErr(emailValid(e.target.value));
    };
    var blurPhone = function (e) {
        return setPhoneErr(phoneValid(e.target.value));
    };
    return (react_1.default.createElement(GenericModal_1.default, { open: open, onClose: handleClose },
        react_1.default.createElement(styles_1.default.CheckIconWrapper, { iconref: iconref }),
        react_1.default.createElement(styles_1.default.ContentWrapper, { ref: dialogRef, className: "content-wrapper" },
            react_1.default.createElement(styles_1.default.DialogTitle, null,
                react_1.default.createElement(atoms_1.Header3, null, props.title),
                react_1.default.createElement(CloseIconSmall_1.default, { onClick: handleClose })),
            react_1.default.createElement(styles_1.default.Content, null,
                react_1.default.createElement(styles_1.default.ContentText, null, "\u0414\u0435\u0442\u0430\u043B\u0438, \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0438 \u0441\u0440\u043E\u043A\u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u0437\u0430\u043A\u0430\u0437\u0430 \u0443\u0442\u043E\u0447\u043D\u0438\u043C \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0447\u0430\u0441\u0430"),
                react_1.default.createElement(GenericInput_1.default, { value: email, label: 'E-mail *', onBlur: blurEmail, onChange: changeEmail, error: emailErr, errorText: 'Пример: johnsnow1@mail.ru', id: "e-mail" }),
                react_1.default.createElement(GenericInput_1.default, { component: function (props) { return react_1.default.createElement(StyledPhoneInput, __assign({}, props)); }, value: phone, onChange: changePhone, onBlur: blurPhone, error: phoneErr, errorText: 'Пример: +7(123)456-7890', id: "phone", label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D *" }),
                error && react_1.default.createElement(styles_1.default.Error, null, error),
                success && react_1.default.createElement(styles_1.default.Success, null, success)),
            formName === exports.B2B_CTA_FORM && (react_1.default.createElement(styles_1.default.Recaptcha, { className: "g-recaptcha", "data-sitekey": props.siteKey })),
            react_1.default.createElement(styles_1.default.Button, { onClick: submit, disabled: !phone || !email || phoneValid(phone) || emailValid(email) }, props.btnTitle),
            react_1.default.createElement(styles_1.default.Content, null,
                react_1.default.createElement(styles_1.default.ContentText, null,
                    "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443, \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441",
                    ' ',
                    react_1.default.createElement("a", { href: "/legal", target: "_blank" }, "\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F"),
                    ' ',
                    "\u0438",
                    react_1.default.createElement("a", { href: "/legal", target: "_blank" },
                        ' ',
                        "\u043F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438"))))));
};
var animateModal = function (onClose, dialogRef, iconref) {
    var contentWrapper = dialogRef.current;
    if (!contentWrapper)
        return;
    console.log(contentWrapper);
    var checkIconWrapper = iconref.current;
    if (!checkIconWrapper)
        return;
    console.log(checkIconWrapper);
    var contentAnim = contentWrapper.animate.apply(contentWrapper, styles_1.contentWrapperAnimOptions);
    contentAnim.addEventListener('finish', function () {
        checkIconWrapper.style.display = 'block';
        var checkIconAnim = checkIconWrapper.animate.apply(checkIconWrapper, styles_1.checkIconWrapperAnimOptions);
        checkIconAnim.addEventListener('finish', function () {
            onClose && onClose();
            setTimeout(function () {
                contentAnim.cancel();
                checkIconAnim.cancel();
                checkIconWrapper.style.display = 'none';
            }, 200);
            contentWrapper.style.display = '';
        });
    });
};
var StyledPhoneInput = GenericInput_1.StyledInput.withComponent(InputMask_1.default);
exports.default = PopupForm;
